import "./UcWindow.0.css";
import { startMouseMove } from './utils/browser/mouseMove';
import defaultWindowIcon from './assets/defaultWindowIcon.svg';
import { vueLinkLocalStorage } from "../lib/utils/vue";
import { throttle } from "lodash-es";
const __script_base__ = {
  name: 'UcWindow',
  props: {
    left: String,
    // 支持 .sync
    top: String,
    // 支持 .sync
    title: String,
    visible: Boolean,
    // 支持 .sync
    width: {
      type: String,
      default: ''
    },
    icon: {
      type: String,
      default: defaultWindowIcon
    },
    minHeight: {
      type: String,
      default: ''
    },
    closable: {
      type: Boolean,
      default: true
    },
    minimizable: {
      type: Boolean,
      default: false
    },
    maxWidth: {
      type: Number,
      default: 0
    },
    // 如果设置了，就会运行拖拽调整宽度
    noPadding: {
      type: Boolean,
      default: false
    },
    defaultMinimized: {
      type: Boolean,
      default: false
    },
    styleStorageId: {
      type: String,
      default: ''
    },
    // 缓存某些历史样式 如宽度
    draggable: {
      type: Boolean,
      default: true
    },
    autoShrinkHeight: {
      type: Boolean,
      default: false
    } // 窗口底部溢出浏览器之外时，动态缩小 .ucdWindow-container 的高度并显示滚动条
  },
  data() {
    return {
      minimized: this.defaultMinimized,
      currentWidth: '',
      tempLeft: this.left,
      tempTop: this.top,
      containerMaxHeight: ''
    };
  },
  created() {
    if (this.styleStorageId) {
      vueLinkLocalStorage(this, `UcWindow${this.styleStorageId}`, 'currentWidth');
    }
  },
  mounted() {
    // watch width immediate拆出来放到这里 避免和linkStorage冲突
    if (this.width) {
      this.minWidth = parseFloat(this.width);
      if (!this.currentWidth) {
        this.currentWidth = this.width;
      }
    }
    this.$watch('width', w => {
      if (!w) {
        this.currentWidth = 'auto';
      } else {
        this.currentWidth = w;
      }
    });
    this.$watch('visible', v => {
      if (v) {
        this.tempLeft = this.left;
        this.tempTop = this.top;
      }
    });
    this.$watch('left', v => {
      this.tempLeft = v;
    });
    this.$watch('top', v => {
      this.tempTop = v;
    });
    this.onBrowserWindowResize = throttle(this.onBrowserWindowResize, 300);
    this.$watch(() => !!(this.visible && this.autoShrinkHeight) && parseInt(this.top, 10), x => {
      const enabled = typeof x === 'number';
      if (!!this.onBrowserWindowResizeListening !== enabled) {
        this.onBrowserWindowResizeListening = enabled;
        if (enabled) {
          window.addEventListener('resize', this.onBrowserWindowResize);
        } else {
          window.removeEventListener('resize', this.onBrowserWindowResize);
          this.containerMaxHeight = '';
        }
      }
      if (enabled) {
        // maybe `top` changed
        this.$nextTick(() => this.onBrowserWindowResize());
      }
    }, {
      immediate: true
    });
  },
  beforeDestroy() {
    if (this.onBrowserWindowResizeListening) {
      this.onBrowserWindowResizeListening = false;
      window.removeEventListener('resize', this.onBrowserWindowResize);
    }
  },
  computed: {
    windowStyle() {
      const ans = `left:${this.tempLeft}; top:${this.tempTop}; width:${this.currentWidth}; min-height: ${this.minHeight};`;
      return ans;
    },
    floatButtonStyle() {
      const ans = `left:${this.tempLeft}; top:${this.tempTop};`;
      return ans;
    }
  },
  methods: {
    closeWindow() {
      this.$emit('update:visible', false);
      this.$emit('close');
    },
    startResizeWidth(event) {
      const currentWidth = parseFloat(this.currentWidth);
      const {
        minWidth,
        maxWidth
      } = this;
      startMouseMove({
        initialEvent: event,
        onMove: ({
          deltaX
        }) => {
          this.currentWidth = `${Math.max(minWidth, Math.min(currentWidth + deltaX, maxWidth))}px`;
        }
      });
    },
    startMove(event) {
      if (event.target.matches('button')) return;
      if (!this.draggable) return;
      this.$el.style.cursor = 'move';
      const oX = parseFloat(this.tempLeft);
      const oY = parseFloat(this.tempTop);
      let {
        tempLeft: left,
        tempTop: top
      } = this;
      startMouseMove({
        initialEvent: event,
        onMove: ({
          deltaX,
          deltaY
        }) => {
          const offsetTop = Math.max(oY + deltaY, 0);
          const offsetLeft = Math.max(0, oX + deltaX);
          // const offsetLeft = Math.min(
          //   Math.max(0, oX + deltaX);
          //   this.$el.offsetParent.offsetWidth - parseFloat(this.$el.getBoundingClientRect().width),
          // );

          left = `${offsetLeft}px`;
          top = `${offsetTop}px`;
          this.$el.style.left = left;
          this.$el.style.top = top;
          this.onBrowserWindowResize();
        },
        onEnd: ({
          duration
        }) => {
          this.tempLeft = left;
          this.tempTop = top;
          this.$emit('update:top', top);
          this.$emit('update:left', left);
          this.$el.style.cursor = 'default';
          if (this.minimized && duration < 200) this.minimized = false; // 点击小按钮要展开面板
        }
      });
    },
    onBrowserWindowResize() {
      const container = this.visible && this.autoShrinkHeight && this.$refs.container;
      if (!container) {
        this.containerMaxHeight = 'auto';
        return;
      }
      const {
        top
      } = container.getBoundingClientRect();
      this.containerMaxHeight = `${Math.max(20, window.innerHeight - top - 40)}px`;
    }
  },
  watch: {
    minimized(value) {
      if (!value) {
        this.$emit('refresh-style');
      }
    }
  }
};
var render = function () {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return !_vm.visible ? _c("div", {
    staticClass: "ucdWindow-closedPlaceholder"
  }) : _vm.minimized ? _c("div", {
    staticClass: "ucdWindow-floatButton",
    style: _vm.floatButtonStyle,
    on: {
      mousedown: _vm.startMove,
      touchstart: _vm.startMove
    }
  }, [_c("img", {
    staticClass: "ucdWindow-floatButton-icon",
    attrs: {
      src: _vm.icon
    }
  }), _vm._v(" "), _c("div", {
    staticClass: "ucdWindow-floatButton-title"
  }, [_vm._v("\n    " + _vm._s(_vm.title) + "\n  ")])]) : _c("div", {
    staticClass: "ucdWindow",
    class: {
      noPadding: _vm.noPadding
    },
    style: _vm.windowStyle
  }, [_c("div", {
    staticClass: "ucdWindow-asider"
  }, [_vm._t("asider")], 2), _vm._v(" "), _vm.maxWidth ? _c("div", {
    staticClass: "ucdWindow-rightSizer",
    on: {
      mousedown: _vm.startResizeWidth,
      touchstart: _vm.startResizeWidth
    }
  }) : _vm._e(), _vm._v(" "), _c("div", {
    staticClass: "ucdWindow-main"
  }, [_c("div", {
    staticClass: "ucdWindow-header",
    on: {
      mousedown: _vm.startMove,
      touchstart: _vm.startMove
    }
  }, [_c("div", {
    staticClass: "ucdWindow-title"
  }, [_vm._t("header", function () {
    return [_vm._v("\n          " + _vm._s(_vm.title) + "\n        ")];
  })], 2), _vm._v(" "), _c("div", [_vm.minimizable ? _c("button", {
    staticClass: "ucdWindow-minimizeButton",
    on: {
      click: function ($event) {
        _vm.minimized = true;
      }
    }
  }, [_vm._v("\n          -\n        ")]) : _vm._e(), _vm._v(" "), _vm.closable ? _c("button", {
    on: {
      click: _vm.closeWindow
    }
  }, [_vm._v("\n          x\n        ")]) : _vm._e()])]), _vm._v(" "), _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.minimized,
      expression: "!minimized"
    }],
    ref: "container",
    staticClass: "ucdWindow-container",
    class: {
      withAutoShrinkHeight: _vm.autoShrinkHeight
    },
    style: {
      maxHeight: _vm.containerMaxHeight
    }
  }, [_vm._t("default")], 2)])]);
};
var staticRenderFns = [];
render._withStripped = true;
const __script__ = __script_base__;
export default Object.assign({
  render,
  staticRenderFns,
  _compiled: true
}, {
  "__file": "UcWindow.vue"
}, typeof __script__ === 'function' ? __script__.options : __script__);